import { render, staticRenderFns } from "./ImagenesProductos.vue?vue&type=template&id=4c02e0bf"
import script from "./ImagenesProductos.vue?vue&type=script&lang=js"
export * from "./ImagenesProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports